/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import { Tabs } from 'antd';
import './CSS/Dashboard.css';
import Dashboard from './Dashboard';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { API_DASHBOARD } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import {StyledHomepage} from '../../../commons/styles/layout';

const Dashboards = (props) => {
  const [dashboardList, setDashboardList] = useState([]);

  let pathname = props.match.pathname;
  let groupName = pathname.split('/rubus/dashboards/');

  useEffect(() => {
    document.title = 'Dashboard - ' + groupName[1];
    _getDashboardListFromGroup(groupName[1]);
  }, [groupName[1]]); // Dependency array ensures this runs when groupName changes

  const _getDashboardListFromGroup = (groupName) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const ParameterTypeObject = {
      method: 'POST',
      url: `${API_DASHBOARD.GetNameByGroup}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        GroupName: groupName
      }
    };
    
    axios(ParameterTypeObject)
      .then((response) => {
        setDashboardList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching dashboard list:", error);
      });
  };

  return (
    <StyledHomepage>
      {dashboardList && Array.isArray(dashboardList) ? (
        <Tabs style={{ color: 'white' }}>
          {dashboardList && Array.isArray(dashboardList) && dashboardList.map((dashboardName) => (
            <Tabs.TabPane tab={dashboardName} key={dashboardName}>
              <Dashboard match={{ params: { name: dashboardName } }} />
            </Tabs.TabPane>
          ))}
        </Tabs>
      ) : null}
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(Dashboards);
